import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { queryClient } from "./query-client";
import { AuthProvider } from "@entities/auth";
import { ToastContainer } from "react-toastify";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import * as Sentry from "@sentry/react";



import "./index.css";
import 'react-toastify/dist/ReactToastify.css';
import "./i18n" ;
import { VirusProvider } from "@entities/virus";
import { initStripe } from "./stripe";

initStripe();

if(process.env.NODE_ENV === "production"){
    Sentry.init({
      dsn: "https://620fa4fb453430991e4c33f82ce0c853@o4506789737267200.ingest.us.sentry.io/4510271684280320",
      integrations: [
        Sentry.browserTracingIntegration({
          traceFetch: true,
        }),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
          networkCaptureBodies: true,
          networkDetailAllowUrls: [
            window.location.origin, 
            "localhost",
            /^https:\/\/fixransomware\.com\/api/, 
            /^https:\/\/admin-v4.fixransomware\.com\/api/,
            /^https:\/\/admin.fixransomware\.com\/api/
          ],
        })
      ],
      sendDefaultPii: true,
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/fixransomware\.com\/api/, /^https:\/\/admin-v4.fixransomware\.com\/api/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}



const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <VirusProvider>
          <RouterProvider router={router} />
          <ToastContainer pauseOnFocusLoss={false} />
        </VirusProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
